module.exports = __webpack_public_path__ + "img/evenware-logo.f460d12b.jpg";